module.exports = __webpack_public_path__ + "static/SRS-1-7dc5d9ee0f698e70abd2ecb3cf40940c.jpg";